module.exports = __webpack_public_path__ + "img/img-addonetether-sec-10.png";